import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mt-5 mb-4" }
const _hoisted_4 = { class: "card-container grid row-gap-4" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "button-group mt-2" }
const _hoisted_9 = { class: "w-full" }

import { inject } from 'vue';
import { ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
//--- Function imports

//### Service imports
import ChangePasswordService from './change-password.service';
//--- Service imports

//### Model imports
import { validationRules } from './change-password.validation';
import { validationState } from './change-password.validation';

import { GeneralInputType } from '@rednex/gateway_core';
//--- Model imports

//### Component imports
import { GeneralInput } from '@rednex/gateway_core';
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'change-password-modal',
  setup(__props) {

//### Function imports
const changePasswordService = inject<ChangePasswordService>('changePasswordService');

const v$ = useVuelidate(validationRules, validationState);
//--- Setup

//### Store/Reactive Data
//--- Store/Reactive Data

//### Variables const let
const doNotMatch = ref(null);
const error = ref(null);
const success = ref(null);
//--- Variables const let

//### Component Lifecycle
//--- Component Lifecycle

//### Functions
function changePassword(): void {
  if (validationState.newPassword !== validationState.confirmPassword) {
    error.value = null;
    success.value = null;
    doNotMatch.value = 'ERROR';
  } else {
    doNotMatch.value = null;
    changePasswordService
      .changePassword(validationState.currentPassword, validationState.newPassword)
      .then(() => {
        success.value = 'OK';
        error.value = null;
      })
      .catch(() => {
        success.value = null;
        error.value = 'ERROR';
      });
  }
}
//--- Functions

return (_ctx: any,_cache: any) => {
  const _component_InlineMessage = _resolveComponent("InlineMessage")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_unref(validationState))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (success.value || error.value || doNotMatch.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (success.value)
                ? (_openBlock(), _createBlock(_component_InlineMessage, {
                    key: 0,
                    class: "w-full",
                    severity: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('password.messages.success')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (error.value)
                ? (_openBlock(), _createBlock(_component_InlineMessage, {
                    key: 1,
                    class: "w-full",
                    severity: "error"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('password.messages.error')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (doNotMatch.value)
                ? (_openBlock(), _createBlock(_component_InlineMessage, {
                    key: 2,
                    class: "w-full",
                    severity: "warn"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.passwordsDontMatch')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (changePassword()), ["prevent"])),
            name: "form",
            role: "form",
            novalidate: ""
          }, [
            _createCommentVNode(" Fields "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(GeneralInput), {
                  modelValue: _unref(validationState).currentPassword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(validationState).currentPassword) = $event)),
                  id: 'currentPassword',
                  inputType: _unref(GeneralInputType).PASSWORD,
                  v$: _unref(v$).currentPassword,
                  langKey: "form.currentPasswordLabel"
                }, null, 8 /* PROPS */, ["modelValue", "inputType", "v$"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(GeneralInput), {
                  modelValue: _unref(validationState).newPassword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(validationState).newPassword) = $event)),
                  id: 'newPassword',
                  inputType: _unref(GeneralInputType).PASSWORD,
                  v$: _unref(v$).newPassword,
                  langKey: "form.newPasswordLabel"
                }, null, 8 /* PROPS */, ["modelValue", "inputType", "v$"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(GeneralInput), {
                  modelValue: _unref(validationState).confirmPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(validationState).confirmPassword) = $event)),
                  id: 'confirmPassword',
                  inputType: _unref(GeneralInputType).PASSWORD,
                  v$: _unref(v$).confirmPassword,
                  langKey: "form.confirmPasswordLabel"
                }, null, 8 /* PROPS */, ["modelValue", "inputType", "v$"])
              ])
            ]),
            _createCommentVNode(" Footer "),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Button, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (changePassword())),
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "save" }),
                  _createTextVNode("   "),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('save')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ])
          ], 32 /* HYDRATE_EVENTS */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})